import { useTheme } from '@mui/material';
import type React from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AppConstantsContext } from '../../../context';
import { JobType } from '../../../entities';
import { getEarlyBirdSaleEvent } from './saleEvents/EarlyBirdSale';
import { getHalloweenSale } from './saleEvents/HalloweenSale';

export interface SaleEventProps {
  name: string;
  discountData: {
    discount: number;
    discountedSubscriptions: string[];
    code: string;
  };
  title?: string;
  subtitle?: string;
  borderText?: string;
  navigationText?: string;
  backgroundAnimation?: React.ReactNode;
  styles?: {
    paper?: React.CSSProperties;
    title?: React.CSSProperties;
    subtitle?: React.CSSProperties;
    defaultStyles?: React.CSSProperties;
    card?: React.CSSProperties;
    button?: any;
    radioContainer?: React.CSSProperties;
    radioBorderText?: React.CSSProperties;
    price?: React.CSSProperties;
    bestValue?: React.CSSProperties;
    navigationButton?: any;
    '@global'?: any;
    '&::before'?: any;
    '&::after'?: any;
    '@media (max-width: 600px)'?: React.CSSProperties;
  };
}

export const showEventByDate = (startDate: Date, endDate: Date): boolean => {
  const curDate = new Date();
  return (
    (startDate <= curDate && curDate <= endDate) ||
    (typeof window !== 'undefined' && window.location?.search?.includes('test'))
  );
};

const useSaleEvent = () => {
  const { jobType, subscriptionIds, isMusehub } = useContext(AppConstantsContext);
  const theme = useTheme();
  const { t } = useTranslation();
  let saleEvent: SaleEventProps | null = null;
  if (isMusehub) {
    saleEvent = null;
  } else if (jobType === JobType.TranscribeStudio) {
    saleEvent = getEarlyBirdSaleEvent(theme, t);
  } else if (showEventByDate(new Date('2025-10-17 12:00'), new Date('2025-11-03 12:00'))) {
    saleEvent = getHalloweenSale(theme, t);
    if (
      !Object.values(subscriptionIds).find((subscriptionId: string) =>
        saleEvent?.discountData.discountedSubscriptions.includes(subscriptionId)
      )
    ) {
      saleEvent = null;
    }
  }
  return {
    saleEvent,
  };
};

export default useSaleEvent;
